import styled from 'styled-components';

export const ButtonGroup = styled.div<{ gap?: string; justification?: string }>`
  display: flex;
  justify-content: ${({ justification }) => justification || 'flex-start'};
  gap: ${({ gap }) => gap || '10px'};
`;
